import $ from 'jquery';
import '../plp/plp-lazy-load';
import horizontalScrollmenu from './horizontal-scroll-menu';
import heartProduct from "modules/heart-product";

function bindHeartItems() {
  heartProduct('#pageItems', '.fav-item');
}

function initHorizontalScrollmenu() {
  horizontalScrollmenu();
}

$(document).ready(function() {
  $('.js-designers-lazy-load').plpLazyLoad({
    sessionName: 'designerSessionData',
    loadAfterCallback: function() {
        $('.js-designers-lazy-img').lazy({
            bind: "event",
            threshold: 1500,
        });
    }
});
  if($('.js-scroll-menu').length) {
    initHorizontalScrollmenu();
  }
  $('.js-favorite-designer').on('click', function() {
    $(this).toggleClass('favorite-button--heart-active');
  });
  bindHeartItems();
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/designers/index.js